<template>
  <v-dialog 
    v-model="navigation.closeCRMWhatsappConversationDialogIsVisible" 
    @update:model-value="navigation.closeCRMWhatsappConversationDialogIsVisible == false ? closeCRMWhatsappConversationDialog() : null" 
    max-width="80vw" 
    style="user-select: none; cursor: default;"
  >    
    <v-card style="max-height: 90vh; display: flex; flex-direction: column;">
      <div style="position: sticky; top: 0; z-index: 10; background: white;">
        <v-card color="primary" rounded="0" elevation="0" class="headerCard">
          <div class="titleContainer">
            <v-icon color="indigo" size="large">mdi-chat-remove</v-icon>
            <h3>FINALIZAR CONVERSACIÓN</h3>
          </div>
          <div class="actionsContainer">
            <template v-if="display.CRMWhatsappConversation">
              <template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == display.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID)">
                <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == display.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" label>
                  <div style="display: flex; align-items: center;">
                    <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == display.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == display.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                  </div>
                </v-chip>
              </template>
              <template v-else>
                <v-chip color="primary" variant="flat" elevation="2" label>
                  <div style="display: flex; align-items: center;">
                    <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <p>No registrado</p>
                  </div>
                </v-chip>
              </template>
            </template>
            <v-btn 
              @click="closeCRMWhatsappConversationDialog()"
              :disabled="loader.selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog || loader.closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog"
              color="error" 
              class="hoverableText" 
            >
              <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
              <p>CERRAR</p>
            </v-btn>
          </div>
        </v-card>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
      </div>
      <div style="flex: 1; overflow-y: auto;">
        <div v-if="display.CRMWhatsappConversation" class="dataContainer">
          <div style="display: flex; flex-direction: column; gap: 10px;">
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-barcode</v-icon>
              <p><strong>ID: </strong>{{ display.CRMWhatsappConversation.CRMWhatsappConversationID }}</p>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-card-account-details</v-icon>
              <p><strong>SSN: </strong>{{ display.CRMWhatsappConversation.CRMWhatsappContactSSN || 'No registrado' }}</p>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-account</v-icon>
              <p><strong>Nombre: </strong>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(display.CRMWhatsappConversation) }}</p>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-phone</v-icon>
              <p><strong>Teléfono: </strong>{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(display.CRMWhatsappConversation.CRMWhatsappContactPhoneNumber) }}</p>
            </div>
          </div>
          <div style="display: flex; flex-direction: column; gap: 10px;">
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-email</v-icon>
              <p><strong>Correo electrónico: </strong>{{ display.CRMWhatsappConversation.CRMWhatsappContactEmail || 'No registrado' }}</p>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-store</v-icon>
              <p style="margin-right: 5px;"><strong>Localidad: </strong></p>
              <template v-if="display.CRMWhatsappConversation.CRMWhatsappContactCRMLocalityID && systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == display.CRMWhatsappConversation.CRMWhatsappContactCRMLocalityID)">
                <v-chip :color="systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == display.CRMWhatsappConversation.CRMWhatsappContactCRMLocalityID).CRMLocalityColor || 'primary'" variant="flat" elevation="2" label>
                  <p>{{ systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == display.CRMWhatsappConversation.CRMWhatsappContactCRMLocalityID).CRMLocalityName || 'No registrada' }}</p>
                </v-chip>
              </template>
              <template v-else>
                <v-chip color="primary" variant="flat" elevation="2" label>
                  <p>No registrada</p>
                </v-chip>
              </template>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-calendar-start</v-icon>
              <p><strong>Primera orden: </strong>{{ display.CRMWhatsappConversation.firstCRMWhatsappInvoiceCreationDatetime ? $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(display.CRMWhatsappConversation.firstCRMWhatsappInvoiceCreationDatetime) : 'No registrada' }}</p>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-calendar-end</v-icon>
              <p><strong>Última orden: </strong>{{ display.CRMWhatsappConversation.lastCRMWhatsappInvoiceCreationDatetime ? $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(display.CRMWhatsappConversation.lastCRMWhatsappInvoiceCreationDatetime) : 'No registrada' }}</p>
            </div>
          </div>
        </div>
        <v-card color="borderInner" elevation="0" rounded="0" style="width: 100%; height: 1px;"></v-card>
        <div style="padding: 15px;">
          <v-autocomplete
            ref="CRMWhatsappConversationResult"
            v-model="input.CRMWhatsappConversationResult"
            :items="computed_CRMWhatsappConversationResult"
            :loading="loader.selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog || loader.closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog"
            :disabled="loader.selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog || loader.closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog"
            prepend-inner-icon="mdi-timeline"
            label="Resultado de la conversación"
            variant="outlined"
            density="compact"
            autocomplete="off"
            clearable
            hide-details
          >
            <template v-slot:item="{ props, item }">
              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                <v-list-item 
                  v-bind="props" 
                  :title="null" 
                  :subtitle="null"
                  :active="input.CRMWhatsappConversationResult == item.value"
                  class="hoverableText"
                  style="padding-top: 5px; padding-bottom: 5px;"
                >
                  <template v-slot:prepend>
                    <v-checkbox-btn 
                      :model-value="input.CRMWhatsappConversationResult == item.value" 
                      density="compact" 
                      hide-details 
                      readonly
                      class="hoverableElement"
                      style="margin-right: 10px;"
                    ></v-checkbox-btn>
                  </template>
                  <template v-if="item.title == 'Seguimiento de contacto'">
                    <v-chip color="success" variant="flat" elevation="2" density="compact" label style="margin: 5px 0px;">
                      <p>{{ item.title }}</p>
                    </v-chip>
                  </template>
                  <template v-else>
                    <p>{{ item.title }}</p>
                  </template>
                  
                </v-list-item>
              </v-list>
            </template> 
          </v-autocomplete>
          <v-textarea
            ref="CRMWhatsappConversationNote"
            v-model="input.CRMWhatsappConversationNote"
            label="Nota de la conversación (opcional)"
            prepend-inner-icon="mdi-note"
            :loading="loader.selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog || loader.closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog"
            :disabled="loader.selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog || loader.closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog"
            variant="outlined"
            density="compact"
            rows="3"
            max-rows="5"
            autocomplete="off"
            auto-grow
            clearable
            hide-details
            style="margin-top: 15px;"
          ></v-textarea>
          <v-checkbox-btn
            v-model="input.sendCRMWhatsappConversationFeedback"
            :disabled="loader.selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog || loader.closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog"
            color="indigo"
            density="compact"
            label="Enviar feedback al contacto"
            hide-details
            class="hoverableText"
            style="margin-top: 15px;"
          ></v-checkbox-btn>
        </div>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
        <v-card color="primary" elevation="0" rounded="0" style="padding: 15px;">
          <v-tooltip :disabled="validateInputForCloseCRMWhatsappConversationDialog(false).success" location="top"> 
            <template v-slot:activator="{ props }">
              <div v-bind="props">
                <v-btn 
                  @click="closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog()" 
                  :disabled="!validateInputForCloseCRMWhatsappConversationDialog(false).success || loader.selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog || loader.closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog" 
                  color="indigo"
                  class="hoverableText"
                  block
                >
                  <v-icon style="margin-right: 10px;">mdi-chat-remove</v-icon>
                  <h3>FINALIZAR CONVERSACIÓN</h3>
                </v-btn>
              </div>
            </template>
            <span style="max-width: 400px; display: block;">{{ validateInputForCloseCRMWhatsappConversationDialog(false).result }}</span>
          </v-tooltip>
        </v-card>
      </div>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
 .headerCard {
    padding: 15px;
    display: grid;
    justify-content: center;
    align-items: center;
    gap: 10px;
    grid-template-columns: repeat(2, 1fr);
  }
  
  .titleContainer {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .actionsContainer {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  .dataContainer {
    padding: 15px;
    gap: 10px;
    display: grid;
    justify-content: center;
    align-items: center;
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 1200px) {
    .headerCard {
      grid-template-columns: repeat(1, 1fr);
    }

    .titleContainer {
      justify-content: center;
    }

    .actionsContainer {
      justify-content: center;
      margin-left: 0;
    }

    .dataContainer {
      grid-template-columns: repeat(1, 1fr);
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    data: () => 
    ({
      input: 
      {
        CRMWhatsappConversationResult: 'Vuelve a escribir',
        CRMWhatsappConversationNote: null,
        sendCRMWhatsappConversationFeedback: false
      },
      display: 
      {
        CRMWhatsappConversation: null
      },
      navigation: 
      {
        closeCRMWhatsappConversationDialogIsVisible: false,
        CRMWhatsappConversationCanBeFollowup: false,
        CRMWhatsappConversationID: null,
        CRMWhatsappContactID: null
      },
      loader: 
      {
        selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog: false,
        closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        CRMAgents: [],
        CRMLocalities: [],
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    computed:
    {
      computed_CRMWhatsappConversationResult(){
        const CRMWhatsappConversationResult = 
        [
          'Vuelve a escribir',
          ...(this.navigation.CRMWhatsappConversationCanBeFollowup == true ? ['Seguimiento de contacto'] : []),
          'Venta perdida',
          'Venta para otro día',
          'Consulta de producto(s) sin venta',
          'Nunca contestó',
          'Dejó de contestar',
          'Venta en localidad física',
          'Consulta de información general sin venta',
          'Solicitud de garantía', 'Reclamo',
          'Sugerencia',
          'Menor de edad',
          'Otro'
        ];
        return CRMWhatsappConversationResult;
      }
    },

    methods:
    {

      async selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog(){
        const selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialogRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversationID,
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID
        };
        const selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/functions/selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog', selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialogRequestQuery);
        if (selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialogResult.success){
          this.display.CRMWhatsappConversation = selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialogResult.result;
          this.navigation.CRMWhatsappConversationCanBeFollowup = this.display.CRMWhatsappConversation.CRMWhatsappConversationCanBeFollowup;
          this.loader.selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog_error', 'error', 'Ha ocurrido un error inesperado al obtener la conversación, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.closeCRMWhatsappConversationDialog();
        }
      },

      async closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog(){
        if (this.validateInputForCloseCRMWhatsappConversationDialog(true).success){
          this.loader.closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog = true;
          const closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialogRequestQuery = 
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
            },
            'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversationID,
            'CRMWhatsappConversationPhoneNumber': this.display.CRMWhatsappConversation.CRMWhatsappContactPhoneNumber,
            'CRMWhatsappConversationResult': this.input.CRMWhatsappConversationResult,
            'CRMWhatsappConversationNote': this.input.CRMWhatsappConversationNote,
            'sendCRMWhatsappConversationFeedback': this.input.sendCRMWhatsappConversationFeedback
          };
          const closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/functions/closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog', closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialogRequestQuery);
          if (closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialogResult.success){
            this.closeCRMWhatsappConversationDialog();
          } else {  
            this.$root.notificationDialog.showSystemNotificationDialog('closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog_error', 'error', 'Ha ocurrido un error inesperado al finalizar la conversación, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
          this.loader.closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog = false;
        }
      },

      validateInputForCloseCRMWhatsappConversationDialog(showSystemNotificationDialog){
        if (!this.input.CRMWhatsappConversationResult){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCloseCRMWhatsappConversationDialog_missingCRMWhatsappConversationResult', 'warning', 'El resultado de la conversación es obligatorio', null, false);
          return {success: false, result: 'El resultado de la conversación es obligatorio'};
        } else if (this.input.CRMWhatsappConversationNote && this.input.CRMWhatsappConversationNote.length > 65535){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCloseCRMWhatsappConversationDialog_CRMWhatsappConversationNoteTooLong', 'warning', 'La nota de la conversación no puede exceder los 65535 caracteres', null, false);
          return {success: false, result: 'La nota de la conversación no puede exceder los 65535 caracteres'};
        }
        return {success: true, result: null};
      },

      async getSystemInformationData(){
        this.loader.selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog = true;
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            if (!this.systemInformationData.updateSubscription){
              this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
                this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
              });
            }          
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('closeCRMWhatsappConversationDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
            this.closeCRMWhatsappConversationDialog();
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('closeCRMWhatsappConversationDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          this.closeCRMWhatsappConversationDialog();
        }
      },

      async openCloseCRMWhatsappConversationDialog(CRMWhatsappConversationID, CRMWhatsappContactID){
        await this.getSystemInformationData();
        this.navigation.CRMWhatsappConversationID = CRMWhatsappConversationID;
        this.navigation.CRMWhatsappContactID = CRMWhatsappContactID;
        this.display.CRMWhatsappConversation = null;
        this.input.CRMWhatsappConversationResult = 'Vuelve a escribir';
        this.input.CRMWhatsappConversationNote = null;
        this.input.sendCRMWhatsappConversationFeedback = false;
        this.navigation.closeCRMWhatsappConversationDialogIsVisible = true;
        await this.selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog();
        this.$generalFunctions.default.focusInput(this, 'CRMWhatsappConversationNote');
      },

      closeCRMWhatsappConversationDialog(){
        this.navigation.closeCRMWhatsappConversationDialogIsVisible = false;
        this.$emit('closeCRMWhatsappConversationDialog');
      }
    }
  }
</script>